import React from 'react';

import TInputHelper from './TInputHelper';
import { TextRegular } from '../../components/Text';

const InputHelper = ({ children }: TInputHelper) => (
  <TextRegular as="span" color="text-secondary" name="helper">
    {children}
  </TextRegular>
);

export default InputHelper;
